module.exports = __webpack_public_path__ + "img/city13.d40c32d8.jpg";